import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="wrapper">
        <p id="helloYou">hello you!</p>
      </div>
    </div>
  );
}

export default App;
